<template>
    <div class="py-12">
        <div class="max-w-7xl mx-auto px-4 lg:px-8">
            <div class="bg-white overflow-hidden shadow-sm">
                <div
                    class="
                        px-4
                        py-8
                        lg:px-16 lg:py-12
                        bg-white
                        border-b border-gray-200
                    "
                >
                    <!-- Title -->
                    <div
                        class="
                            text-2xl
                            font-medium
                            text-secondary
                            tracking-wide
                            mb-2
                        "
                    >
                        {{ title }}
                    </div>

                    <!-- Total Count -->
                    <div
                        v-if="totalCount > 0"
                        class="text-gray-400 italic mb-2"
                    >
                        Total Count: {{ totalCount }}
                    </div>

                    <!-- For Large Screen -->
                    <!-- Column Header -->
                    <div
                        class="
                            hidden
                            lg:grid
                            grid-cols-4
                            p-2
                            font-medium
                            text-gray-500
                            border-b border-gray-200
                        "
                    >
                        <div :class="headerClasses">Image</div>
                        <div :class="headerClasses" v-for="header in headers">
                            {{ header }}
                        </div>
                    </div>

                    <!-- Condition Details -->
                    <div
                        class="hidden lg:grid grid-cols-4 p-2 text-secondary"
                        v-for="damage in damages"
                    >
                        <!-- Photo -->
                        <div :class="photoClasses">
                            <img
                                class="rounded"
                                :class="damage.photo ? 'cursor-pointer' : ''"
                                :src="
                                    damage.photo
                                        ? damage.photo
                                        : '/images/no-image.png'
                                "
                                @click="photoZoom(damage.photo)"
                            />
                        </div>

                        <div
                            v-for="(header, key) in headers"
                            :class="damageClasses"
                        >
                            <span v-html="damage[key]"></span>
                        </div>
                    </div>

                    <!-- For Small Screen -->
                    <div
                        class="lg:hidden my-10 text-secondary"
                        v-for="damage in damages"
                    >
                        <!-- Photo -->
                        <div
                            class="flex justify-center my-4"
                            v-if="damage.photo"
                        >
                            <img class="rounded w-56" :src="damage.photo" />
                        </div>

                        <div v-for="(header, key) in headers">
                            <span class="font-medium mr-2">
                                {{ header }}:
                            </span>
                            <span v-html="damage[key]"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        headers: {
            type: Object,
            default: {
                damage_area: "Region/Area",
                damage_type: "Type",
                description: "Description",
            },
        },
        damages: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            headerClasses: ["p-2", "flex"],
            photoClasses: ["p-2", "h-24", "flex"],
            damageClasses: ["p-2", "h-24", "flex", "items-center"],
        };
    },
    computed: {
        totalCount() {
            let count = 0;
            this.damages.forEach(function (damage) {
                count += damage.count;
            });
            return count;
        },
    },
    methods: {
        photoZoom(photo) {
            if (photo) {
                this.$emit("zoom", [photo]);
            }
        },
    },
};
</script>
